import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (label, color) => L.divIcon({
  className: "",
  html: `<div style="background:${color};color:#fff;width:28px;height:28px;border-radius:9999px;display:grid;place-items:center;font:700 12px 'JetBrains Mono',monospace;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3)">${label}</div>`,
  iconSize: [28, 28], iconAnchor: [14, 14],
});

export function RouteMap({ start, stops, height = 320 }) {
  const el = useRef(null);
  const map = useRef(null);
  useEffect(() => {
    if (!el.current) return;
    if (!map.current) {
      map.current = L.map(el.current, { zoomControl: true, attributionControl: true });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: "© OpenStreetMap" }).addTo(map.current);
    }
    const m = map.current;
    const layer = L.layerGroup().addTo(m);
    const pts = [[start.lat, start.lng], ...stops.map((s) => [s.lat, s.lng])];
    L.marker(pts[0], { icon: pin("K", "#D96B43") }).bindPopup("Kitchen (start)").addTo(layer);
    stops.forEach((s) => L.marker([s.lat, s.lng], { icon: pin(s.seq, s.delivery_status === "delivered" ? "#10B981" : "#0F382C") })
      .bindPopup(`<b>${s.seq}. ${s.name}</b><br/>${s.address || ""}`).addTo(layer));
    if (stops.length) L.polyline(pts, { color: "#0F382C", weight: 3, opacity: 0.7, dashArray: "6 6" }).addTo(layer);
    m.fitBounds(L.latLngBounds(pts).pad(0.2), { maxZoom: 15 });
    return () => { layer.remove(); };
  }, [start, stops]);
  useEffect(() => () => { map.current?.remove(); map.current = null; }, []);
  return <div ref={el} style={{ height }} className="w-full overflow-hidden rounded-2xl border border-[#E7E2D6] z-0" data-testid="route-map" />;
}
